import React, { type PropsWithChildren, type FC } from "react";
import classes from "./Background.module.css";
import { motion } from "framer-motion";

type BackgroundProps = PropsWithChildren;

const Background: FC<BackgroundProps> = ({ children }) => {
  return (
    <div className={classes.container_overlay}>
      {children}
    </div>
  );
};

export default Background;
